module.exports = __webpack_public_path__ + "assets/227b20eaf8cbc060477343539732816e.png";